import { render, staticRenderFns } from "./PedidoDetail.vue?vue&type=template&id=1c2abc22&scoped=true"
import script from "./PedidoDetail.vue?vue&type=script&lang=js"
export * from "./PedidoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2abc22",
  null
  
)

export default component.exports